/*
 * @Date: 2022-07-04 17:34:30
 * @LastEditors: hanhuixian hanhuixian@lxrental.com
 */
const whiteSpace = '\n\n'

export default {
  companyProfile: {
    title: "公司簡介",
    desc1: "本集團成立於2004年，總部位於深圳，是國內首家打造多場景及閉環設備全生命週期管理業務模式的公司，股東包括了騰訊、京東、聯想等戰略投資者。我們以客戶為導向的價值觀，指導我們為企業提供圍繞設備全生命週期的低成本、高品質、量身定制的一站式綜合服務解決方案。我們著眼於滿足企業對設備生命週期管理解決方案的需求，提高企業的業務運營效率。直接解決企業在IT設備採購、維護、管理及淘汰處置過程中面臨的痛點，通過設備回收業務、設備訂閱服務、IT技術訂閱服務、設備管理SaaS，緩解企業一次性購買IT設備的巨大資金壓力、技術支持回應慢、IT設備管理靈活性不足及IT設備利用率低的問題。設備全生命週期管理作為一種新興的企業發展趨勢，將辦公環境輕資產、實現可靠高效設備生命週期管理成為可能。",
    desc2: "自成立以來，我們堅持“讓企業輕鬆辦公”的使命，通過幫助企業降低運營成本，實現綠色經濟和共用經濟、提高IT設備的全生命週期利用率，樹立了良好的企業形象。被國務院工信部作為行業標杆認定為“國家中小企業公共服務示範平臺”、國家級專精特新“小巨人”企業，代表行業最高服務能力和水準。我們接下來將進一步宣導一個充滿活力的企業生態系統。"
  },

  management:{
    title: "管理層成員",
    detailT: "個人簡介",
    Hu:{
      name: "胡祚雄先生",
      subName: "董事會主席、執行董事、首席執行官",
      desc: `胡祚雄先生，46歲，於2004年11月創立本集團，自本集團成立以來一直擔任本集團董事會主席、首席執行官兼董事。彼於2022年1月10日獲委任為我們的董事，並於2022年3月24日調任為我們的執行董事。彼負責本集團的整體管理、營運及戰略規劃。${whiteSpace}胡先生在設備全生命週期管理行業擁有廣泛經驗，亦在公司管理、公司治理和信息技術行業擁有愈20年經驗。由於胡先生擁有數字化轉型以及「互聯網+」及產業互聯網升級的實際經驗，故自2018年5月起，胡先生獲委任為中國西南交通大學的客座教授。胡先生亦分別於2019年7月及2018年5月獲委任為中國中小企業協會副會長及深圳市商業聯合會副會長。${whiteSpace}胡先生于2019年11月被《哈佛商業評論》評爲「中國數字化轉型先鋒人物」之一。彼亦於2023年12月被《金融界》評爲「傑出創新發展領袖」之一。於2020年9月，一份載列本集團在胡先生領導下的數字化轉型成就的報告獲中國北京大學的光華管理學院管理案例研究中心選為教學案例庫案例。${whiteSpace}胡先生於1998年6月取得中國湖北理工學院的建造材料與工程專業大專文憑。`,
    },
    Chen: {
      name: "陳修偉先生",
      subName: "執行董事、首席技術官、副總裁",
      desc: `陳修偉先生，38歲，于2019年12月獲委任爲本集團首席技術官兼副總裁。彼于2022年1月10日獲委任爲我們的董事，幷于2022年3月24日調任爲我們的執行董事。彼負責本集團的信息技術應用及研發工作。${whiteSpace}陳先生在信息系統的搭建設計、算法、研發、大數據分析及人工智能方面擁有約13年工作經驗。加入本集團之前，于2010年7月至2011年4月，陳先生擔任微軟亞洲研究院（計算機科學及相關技術研究的專門機構）的助理研究員，主要負責系統開發。于2011年4月至2013年8月，陳先生曾在多家中國TMT（科技、媒體、電信）公司擔任首席技術官，幷爲創辦人之一，主要負責研發工作。于2013年8月至2017年8月，彼于聯交所主板上市的綫上交易服務提供商年年卡集團有限公司（股份代號：3773）擔任首席技術官兼副總裁，主要負責研發工作。于2017年9月至2019年12月，陳先生于深圳市前海第四範式數據技術有限公司擔任華南首席架構師和項目交付總監，該公司爲一家專注于AI技術及相關服務的公司，而彼主要負責系統開發及項目交付。${whiteSpace}陳先生分別于2008年6月及2010年6月取得中國中山大學的計算機科學與技術專業學士學位及計算機軟件與理論專業碩士學位。于2007年11月，彼因參加ACM亞洲編程大賽而榮獲「長春賽區金獎」。`
    },
    Cao: {
      name: "曹維軍先生",
      subName: "執行董事、戰略客戶中心總經理",
      desc: `曹維軍先生，36歲，於2012年3月獲委任為本集團戰略客戶中心總經理。彼於2022年1月10日獲委任為我們的董事，並於2022年3月24日調任為我們的執行董事。彼主要負責本集團的客戶發展以及戰略業務發展。${whiteSpace}加入本集團之前，曹先生於2008年9月至2012年3月在中國一間投資銀行及證券經紀公司中國中投證券有限責任公司任職。${whiteSpace}曹先生於2008年7月取得中國武漢生物工程學院的生物技術及應用專業的大專文憑，並於2022年7月取得中國東北師範大學計算機科學與技術本科文憑。`
    },
    Li: {
      name: "李靖先生",
      subName: "非執行董事",
      desc: `李靖先生，42歲，現任集團非執行董事，主要負責本集團的管理、運營及戰略規劃。同時任京東集團副總裁、京東零售企業業務事業部總裁。${whiteSpace}曾在聯想集團有限公司（股票代碼：992.HK）任職。${whiteSpace}李先生2002年取得中國北方交通大學（現稱北京交通大學）工程學士學位。`
    },
    Jiang: {
      name: "蔣澤立先生",
      subName: "首席財務官、副總裁",
      desc: `蔣澤立先生，41歲，於2019年9月加入本集團擔任首席財務官及副總裁，主要負責並監督本集團的財務管理。${whiteSpace}蔣先生在上市公司的審核、會計、財務管理及財務報告方面擁有約21年經驗。加入本集團之前，彼於2004年7月至2009年7月任職於會計師事務所，主要負責上市公司的審計相關工作。於2010年3月至2014年12月，彼分別擔任唐宮（中國）控股有限公司（一家於聯交所主板上市的餐廳營運及食品生產公司，股份代號：1181）及深圳嘉美軒餐飲有限公司（佳兆業集團控股有限公司（股份代號：1638）的附屬公司，經營連鎖餐飲業務）的財務經理，負責監察公司的財務管理及會計職能。於2014年12月至2019年5月，彼擔任深圳兆邦基集團有限公司（一家專門從事商業物業開發及提供物業管理服務的公司）的財務副總監，主要負責監察該公司財務管理及職能。${whiteSpace}蔣先生自2012年12月以來一直為中國註冊會計師。彼於2004年6月獲得中國中山大學會計學學士學位。`
    },
    Liu: {
      name: "劉炎先生",
      subName: "董事會秘書、資本中心總經理",
      desc: `劉炎先生，33歲，於2018年8月獲委任為董事會秘書及資金中心總經理。彼於2022年3月21日獲委任為本公司聯席公司秘書。劉先生負責並監察本集團企業融資及公司秘書事宜。${whiteSpace}加入本集團之前，彼於2014年4月至2015年3月在中國光大銀行股份有限公司（一家於上海證券交易所（股份代號：601818.SH）及聯交所主板（股份代號：6818）上市的公司）深圳分行擔任客戶關係經理，主要負責企業融資業務。於2015年4月至2018年8月，彼擔任Shenzhen Zhengwei (Group) Co., Ltd.（《財富》世界500強企業之一）財務中心副總監，主要負責債務融資業務。${whiteSpace}劉先生於2021年4月獲得由深圳證券交易所頒發的董事會秘書資格證書。彼亦分別於2015年11月自中國期貨業協會獲得期貨從業人員資格，於2016年5月自中國證券業協會獲得基金從業人員資格，並於2016年6月自中國證券投資基金業協會取得證券從業人員資格。劉先生於2012年6月獲得中國安徽工業大學國際經濟與貿易學士學位。彼其後於2013年12月獲得英國格拉斯哥大學國際貿易與金融碩士學位。`
    },
    // Gan: {
    //   name: "甘志成先生",
    //   subName: "獨立非執行董事",
    //   desc: `甘志成先生，51歲，在集團擔任獨立非執行董事。甘先生有超過22年管理會計、審計與鑒證、稅務、企業服務和跨境並購諮詢經驗。目前是香港會計師公會資深會員、特許公認會計師公會資深會員、英國財務會計師公會資深會員、香港稅務學會資深會員、英國信託與遺產從業者協會會員和香港證券及投資協會會員。目前是香港總商會稅務委員會委員、金融及財資服務委員會委員和中國委員會委員。自2016年起，甘先生一直擔任香港中華總商會委員會委員。${whiteSpace}甘先生現任甘志成會計師事務所的執行事務合夥人、卓富德諮詢集團的董事總經理及甘志成會計師事務所在上海、廣州及北京的代表辦事處的首席代表、卓越商企服務集團有限公司（股票代碼：6989.HK）的獨立非執行董事以及信基沙溪集團有限公司（股票代碼：3603.HK）的公司秘書，兩間公司均於聯交所主板上市。${whiteSpace}甘先生於1993年獲得香港大學理學學士學位。`
    // },
    Xu: {
      name: "徐乃玲女士",
      subName: "獨立非執行董事",
      desc: `徐乃玲女士，57歲，目前在集團擔任獨立非執行董事。在金融和投資行業有超過30年經驗，被深圳市人力資源和社會保障局認證為高級經濟師。${whiteSpace}歷任平安銀行股份有限公司廣州分行行長助理、審計監察部副總經理、風險管理部副經理，中國光大環境（集團）有限公司（“光大環境”，前稱中國光大國際有限公司（股票代碼：257.HK））財務副總監、中國光大水務有限公司（股票代碼：1857.HK）執行董事及光大環保（中國）有限公司董事及財務總監。${whiteSpace}徐女士畢業於西南財經大學金融學專業，並獲得廈門大學高級管理人員工商管理碩士學位。`
    },
    Zhao: {
      name: "姚正旺先生",
      subName: "獨立非執行董事",
      desc: `姚正旺先生，48歲，目前在公司擔任獨立非執行董事，擁有超過20年投資及金融行業以及中國A股上市公司企業管治方面的經驗。於2010年11月獲得深圳證券交易所頒發的董事會秘書資格證書，並於2007年11月獲得中國證券監督管理委員會頒發的上市公司高級管理人員培訓結業證書。${whiteSpace}歷任深圳中華自行車（集團）股份有限公司（000017.SZ；200017.SZ）監事、監事會主席及董事會秘書，現擔任董事；歷任樂山市商業銀行股份有限公司董事，現擔任監事。現任深圳市國晟能源投資發展有限公司監事、嘉興知食坊食品科技有限公司董事、深圳市正瑞能源技術有限公司、深圳市龍鵬投資有限公司及正大能源發展（中國）有限公司監事，以及吉林省富德投資控股有限公司總經理。${whiteSpace}姚先生1997年取得汕頭大學法學學士學位。`
    },
    Zhou: {
      name: "鄒盛和先生",
      subName: "獨立非執行董事",
      desc: `鄒盛和先生，57歲，自2024年11月15日起獲委任為獨立非執行董事，主要負責就本集團的營運、投資及管理提供獨立意見。鄒先生擁有逾42年財務管理經驗。自1982年至2005年，鄒先生先後於湖北及深圳的多家公司擔任經理及財務負責人等多個職位。鄒先生先後於2005年至2010年及2010年至2015年擔任深圳丹邦科技股份有限公司（一家曾於深圳證券交易所上市的公司，深交所股票代碼：002618；中央結算系統股份代號：72618）的財務總監及監事會主席。鄒先生於2015年加入東莞市本潤機器人科技股份有限公司（「本潤機器人」，一家曾於全國中小企業股份轉讓系統上市的公司，股票代碼：870887），先後擔任董事及董事會主席。鄒先生現任本潤機器人董事。${whiteSpace}鄒先生於1986年獲得湖北廣播電視大學財務管理專業大專文憑。`
    },
  },

  corporate: {
    title: "公司治理",
    desc: "致力於保持專業化、規範化和透明化的治理機制。",
    table: {
      title: "董事會組成",
      tag_1: "執行董事",
      tag_2: "非執行董事",
      tag_3: "獨立非執行董事",
      tag_4: "審計委員會",
      tag_5: "薪酬委員會",
      tag_6: "提名委員會",
      Hu: "胡祚雄",
      Chen: "陳修偉",
      Cao: "曹維軍",
      Li: "李靖",
      // Gan: "甘志成",
      Xu: "徐乃玲",
      Zhao: "姚正旺",
      Zhou: "鄒盛和",
      descTag1: "主席",
      descTag2: "成員",
    }
  },

  documents: {
    title: "公司治理文件"
  },

  committee: {
    title: "委員會章程"
  },

  irNetwork: {
    title: "投資者關系聯絡",
    contact: "聯系我們",
    address: "深圳（總部）：深圳市福田區梅林街道孖嶺社區凱豐路10號翠林大廈5層501",
    phone: "電話：",
    mailbox: "郵箱：",
  }
}
